import React from 'react';

const Edukacije = () => {
    return (
         <h1>Edukacije</h1>
    )
}

export default Edukacije;